<template>
  <tr class="table__row relative" @mouseenter="renderRowActions(true)" @mouseleave="renderRowActions(false)">
    <td v-for="header in headers" :key="header.value">
      <template v-if="header.value === 'actions'">
        <div class="relative h-100 px-6">
          <TableColumnActions
            v-if="showActions"
            :table-name="actionsTableName"
            :item="item"
            :static-actions="rowActions"
            :offset="actionsOffset"
          />
        </div>
      </template>
      <template v-else-if="header.value === 'courseType'">
        <TableColumnCourseType :course-type="item.courseType || '-'" :is-swap="isSwap" />
      </template>
      <template v-else-if="header.value === 'arrivalTime'">
        <div>{{ item.arrivalTime != null ? parseSeconds(item.arrivalTime) : '-' }}</div>
      </template>
      <template v-else-if="header.value === 'confidence'">
        {{ formatSuggestedCourseConfidence(item.confidence) }}
      </template>
      <template v-else-if="header.value === 'justification'">
        <v-tooltip bottom max-width="500" :disabled="!hasJustificationTooltip">
          <template #activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ truncatedJustification }}
            </span>
          </template>
          {{ justificationText }}
        </v-tooltip>
      </template>
      <template v-else>
        <span :style="header.value === 'clientName' ? { whiteSpace: 'nowrap' } : {}">
          {{ displayValue(item[header.value]) }}
        </span>
      </template>
    </td>
  </tr>
</template>

<script>
import TableColumnActions from '../Table/Columns/TableColumnActions'
import TableColumnCourseType from '../Table/Columns/TableColumnCourseType'
import parseSeconds from '../../utils/parseSeconds'
import { formatSuggestedCourseConfidence } from '../../utils/suggestedCourseConfidence'

export default {
  components: {
    TableColumnActions,
    TableColumnCourseType
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    rowActions: {
      type: Array,
      required: true
    },
    actionsOffset: {
      type: Object,
      required: true
    },
    actionsTableName: {
      type: String,
      required: true
    }
  },
  data: () => ({
    showActions: false,
    justificationPreviewLength: 20
  }),
  computed: {
    isSwap() {
      return !!this.item.swapCourseId
    },
    justificationText() {
      const value = this.item.justification
      if (value == null || value === '') {
        return null
      }
      return String(value)
    },
    truncatedJustification() {
      if (!this.justificationText) {
        return '-'
      }
      if (this.justificationText.length <= this.justificationPreviewLength) {
        return this.justificationText
      }
      return `${this.justificationText.slice(0, this.justificationPreviewLength)}…`
    },
    hasJustificationTooltip() {
      return this.justificationText != null && this.justificationText.length > this.justificationPreviewLength
    }
  },
  methods: {
    parseSeconds,
    formatSuggestedCourseConfidence,
    displayValue(value) {
      return value == null || value === '' ? '-' : value
    },
    renderRowActions(showActions = false) {
      this.showActions = showActions
    }
  }
}
</script>
